import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../firebase';

const AnalyticsTracker: React.FC = () => {
  const location = useLocation();
  const hasMounted = useRef(false);

  useEffect(() => {
    // Firebase Analytics already tracks the initial page load.
    // We manually track subsequent SPA route changes.
    if (!hasMounted.current) {
      hasMounted.current = true;
      return;
    }

    const pagePath = `${location.pathname}${location.search}${location.hash}`;
    void trackPageView(pagePath);
  }, [location]);

  return null;
};

export default AnalyticsTracker;
